<template>
  <div id="app">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from './components/Header'

export default {
  name: 'App',
  components: {Header}
}
</script>

<style>
* {
  box-sizing: border-box !important;
}

body,
html {
  min-height: 100vh;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
.w-full {
  width: 100%;
}
.hello {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.box {
  width: 500px;
  text-align: left;
  padding: 30px;
}
.form-group {
  margin-bottom: 20px;
}
.form-action {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.without-footer .zi-dialog-footer {
  display: none !important;
}
.zi-dialog-content .zi-progress {
  width: 100%;
}
.zi-toast .message {
  max-width: 95% !important;
}
</style>
